<ion-grid class="ion-no-padding generic-error">
  <ion-row 
    class="ion-no-padding ion-no-margin ion-justify-content-center ion-align-items-center"
  >
    <div class="ion-bg-transparent ion-padding ion-text-center">
      <custom-icon
        [iconName]="image"
        [width]="250"
        [height]="250"
        class="ion-padding icon"
        colorClass="modalIcon"
      ></custom-icon>
        <ion-text class="error-black-text-color">
          <h2>{{ "error.whoops_text" | translate }}</h2>
          <p>{{ "error.something_wrong" | translate }}</p>
        </ion-text>
      <div *ngIf="partnerPid !== 'ent'">
        <ion-button
          *ngIf="showTryAgainButton"
          (click)="reloadCurrentRoute()"
          class="ion-margin fs-3 font500 primary-btn"
          expand="block"
        >
          {{ "error.try_again_btn" | translate }}
        </ion-button>
        <ion-button
          *ngIf="showReloginButton"
          (click)="relogin()"
          class="ion-margin fs-3 font500 primary-btn"
          expand="block"
        >
          {{ "page_status.generic_error.relogin_btn_caption" | translate }}
        </ion-button>
      </div>
    </div>
  </ion-row>
</ion-grid>
<support-widget *ngIf="partnerPid !== 'hom'"></support-widget>
